import { useState, useMemo } from "react";
import { EuiPage, EuiPageBody, EuiBreadcrumb } from "@elastic/eui";
import { Header, SideNav } from "../../navigation";
import { LayoutOutlet } from "../status";
import { Catalog } from "anketa-core/types";
export const Home = ({
  breadcrumbs,
  updateCatalog,
}: {
  breadcrumbs: EuiBreadcrumb[];
  updateCatalog: (c: Catalog) => void;
}): JSX.Element => {
  const initialNavIsOpen = useMemo(() => {
    const stored = localStorage.getItem("anketa.nav.side.isOpen");
    return stored ? stored === "true" : false;
  }, []);

  const [navIsOpen, setNavIsOpen] = useState<boolean>(initialNavIsOpen);

  return (
    <EuiPage>
      {navIsOpen && <SideNav />}
      <EuiPageBody>
        <Header
          breadcrumbs={breadcrumbs}
          navIsOpen={navIsOpen}
          setNavIsOpen={setNavIsOpen}
          updateCatalog={updateCatalog}
        />
        {/* Crashes and unknown routes render inside the layout. */}
        <LayoutOutlet />
      </EuiPageBody>
    </EuiPage>
  );
};
